/*
Пример подключения модулей:
test.js: 
export default function() {}
main.js:
import test from './test';
test();
*/

import App from "./components/App";

const vm = new Vue({
    render: h => h(App),
}).$mount('#vue-root');